import {
  Anchor, Armchair, Award, Beaker, Bed, Beer, Bike, Bird, BookOpen, Box,
  Brush, Cake, Camera, Car, Carrot, Cat, Coffee, Compass, Cpu, Crown,
  Diamond, Dog, Drill, Drumstick, Dumbbell, Fish, Flame, Flower2, Footprints,
  Gamepad2, Gem, Gift, Glasses, Globe, GraduationCap, Hammer, Headphones,
  Heart, Hexagon, Home, IceCream, Lamp, Landmark, Layers, Leaf, Library, Map,
  Microscope, Mountain, Music, Package, Paintbrush, Palette, PawPrint, Pencil,
  PenTool, Pill, Pizza, Plane, Rabbit, Rocket, Ruler, Scissors, Ship,
  ShoppingBag, ShoppingCart, Shirt, Smartphone, Sofa, Soup, Sparkles, Sprout,
  Star, Stethoscope, Store, Sun, Sunrise, Tag, Tent, TentTree, TreeDeciduous,
  TreePine, Trophy, Truck, Utensils, Watch, Waves, Wine, Wrench,
  type LucideIcon,
} from "lucide-react";
import { SITE_BRAND_SYMBOL } from "@/config/site";

const ICON_MAP: Record<string, LucideIcon> = {
  Anchor, Armchair, Award, Beaker, Bed, Beer, Bike, Bird, BookOpen, Box,
  Brush, Cake, Camera, Car, Carrot, Cat, Coffee, Compass, Cpu, Crown,
  Diamond, Dog, Drill, Drumstick, Dumbbell, Fish, Flame, Flower2, Footprints,
  Gamepad2, Gem, Gift, Glasses, Globe, GraduationCap, Hammer, Headphones,
  Heart, Hexagon, Home, IceCream, Lamp, Landmark, Layers, Leaf, Library, Map,
  Microscope, Mountain, Music, Package, Paintbrush, Palette, PawPrint, Pencil,
  PenTool, Pill, Pizza, Plane, Rabbit, Rocket, Ruler, Scissors, Ship,
  ShoppingBag, ShoppingCart, Shirt, Smartphone, Sofa, Soup, Sparkles, Sprout,
  Star, Stethoscope, Store, Sun, Sunrise, Tag, Tent, TentTree, TreeDeciduous,
  TreePine, Trophy, Truck, Utensils, Watch, Waves, Wine, Wrench,
};

interface BrandSymbolProps {
  className?: string;
  /** Override the tenant's configured symbol (e.g. for wizard previews). */
  name?: string;
  "aria-hidden"?: boolean;
}

/**
 * Renders the tenant's brand glyph. Used as the fallback icon in image
 * placeholders, empty states, and "no results" UI. The icon is picked from
 * the curated Lucide catalog (sites/lucide-icon-catalog.ts) at site-creation
 * time and stored in `assets.brandSymbol` in each tenant's site.config.ts.
 *
 * Falls back to Sparkles if the configured name isn't in the catalog —
 * better a generic icon than a broken render.
 */
export default function BrandSymbol({
  className,
  name,
  "aria-hidden": ariaHidden = true,
}: BrandSymbolProps) {
  const iconName = name || SITE_BRAND_SYMBOL;
  const Icon = ICON_MAP[iconName] || ICON_MAP.Sparkles;
  return <Icon className={className} aria-hidden={ariaHidden} />;
}
